function normalizeText(value) {
  return value === null || value === undefined ? '' : String(value).trim();
}

function normalizeCollection(source) {
  if (Array.isArray(source)) {
    return source;
  }

  if (source && typeof source === 'object') {
    return Object.values(source);
  }

  return [];
}

export function mapLegalDocumentsResponseToDto(payload) {
  return normalizeCollection(payload?.documents).map((item) => ({
    uid: normalizeText(item?.uid),
    name: normalizeText(item?.name),
    version: normalizeText(item?.version),
    status: normalizeText(item?.status),
    effectiveDate: normalizeText(item?.effectiveDate),
    expirationDate: normalizeText(item?.expirationDate),
    downloadUrl: normalizeText(item?.downloadUrl),
  })).filter((item) => item.uid || item.name);
}

export function mapLegalContentPageResponseToDto(payload) {
  return {
    uid: normalizeText(payload?.uid),
    key: normalizeText(payload?.key),
    title: normalizeText(payload?.title),
    version: normalizeText(payload?.version),
    effectiveDate: normalizeText(payload?.effectiveDate),
    html: normalizeText(payload?.html),
    createdAt: normalizeText(payload?.createdAt),
    updatedAt: normalizeText(payload?.updatedAt),
  };
}

export function mapLegalContentPageListResponseToDto(payload) {
  return normalizeCollection(payload?.pages)
    .map((item) => mapLegalContentPageResponseToDto(item))
    .filter((item) => item.key);
}

export function buildLegalContentPagePayloadFromForm(form) {
  return {
    title: normalizeText(form?.title),
    version: normalizeText(form?.version),
    effectiveDate: normalizeText(form?.effectiveDate),
    html: normalizeText(form?.html),
  };
}

export function validateLegalContentPagePayload(payload) {
  const errors = {};

  ['title', 'version', 'effectiveDate', 'html'].forEach((key) => {
    if (!normalizeText(payload?.[key])) {
      errors[key] = 'This field is required.';
    }
  });

  return errors;
}

export function mapSystemLegalFieldErrors(requestError) {
  const errors = {};
  const details = Array.isArray(requestError?.errors) ? requestError.errors : [];
  const allowed = new Set([
    'name',
    'version',
    'status',
    'effectiveDate',
    'expirationDate',
    'document',
    'title',
    'html',
  ]);

  details.forEach((item) => {
    const parameter = normalizeText(item?.parameter);
    if (allowed.has(parameter)) {
      errors[parameter] = normalizeText(item?.message) || 'Invalid value';
    }
  });

  return errors;
}
